module.exports = __webpack_public_path__ + "img/thampi-hand.18c46507.png";